import { create } from "zustand";
import type { BlotterEntry } from "../types/trades";

function blotterKey(e: BlotterEntry): string {
  return `${e.trade_id}|${e.book_id}|${e.version}`;
}

interface BlotterState {
  entries: Map<string, BlotterEntry>;
  setSnapshot: (rows: BlotterEntry[]) => void;
  applyDelta: (upserts: BlotterEntry[], removedKeys: string[]) => void;
  clear: () => void;
}

export const useBlotterStore = create<BlotterState>((set, get) => ({
  entries: new Map(),
  setSnapshot: (rows) => {
    const m = new Map<string, BlotterEntry>();
    for (const r of rows) m.set(blotterKey(r), r);
    set({ entries: m });
  },
  applyDelta: (upserts, removedKeys) => {
    const next = new Map(get().entries);
    for (const k of removedKeys) next.delete(k);
    for (const r of upserts) next.set(blotterKey(r), r);
    set({ entries: next });
  },
  clear: () => set({ entries: new Map() }),
}));

export function selectBlotterArray(state: BlotterState): BlotterEntry[] {
  return Array.from(state.entries.values());
}
